/**
 * Shared `useRecommendedAgents` limit so the @-mention picker, AgentSection
 * and preloader collapse into one React Query cache entry.
 */
export const AGENTS_FETCH_LIMIT = 5;
